// material ui icons
import HighlightAltRoundedIcon from '@mui/icons-material/HighlightAltRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';

// material ui
import { Box, IconButton, Tooltip } from '@mui/material';

const HighlightControls = ({
  highlightEnabled,
  onToggle,
  sx,
  labels,
  disabled,
}) => {
  const mergedLabels = {
    toggleOn: 'Disable highlight mode',
    toggleOff: 'Enable highlight mode',
    clear: 'Clear highlights',
    ...labels,
  };

  return (
    <Box display="flex" alignItems="center" gap={1} sx={sx}>
      <Tooltip
        title={
          highlightEnabled ? mergedLabels.toggleOn : mergedLabels.toggleOff
        }
      >
        <IconButton
          onClick={onToggle}
          disabled={disabled}
          color={highlightEnabled ? 'warning' : 'default'}
          size="small"
        >
          {highlightEnabled ? (
            <HighlightOffRoundedIcon fontSize="small" />
          ) : (
            <HighlightAltRoundedIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default HighlightControls;
